"use client";

import React from "react";
import {
  ButtonOutline,
  ButtonDestructive,
} from "@/components/common/StandardButton";
import { Edit, CreditCard, Ban, MoreHorizontal } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { orderActions } from "@/store/actions/order.actions";
// OrderStatus/PaymentStatus intentionally unused in this component

interface OrderActionsProps {
  orderId: string;
}

const OrderActions: React.FC<OrderActionsProps> = ({ orderId }) => {
  const dispatch = useAppDispatch();
  const { selectedOrder, detailsLoading, loadingById } = useAppSelector(
    (state) => state.order,
  );
  const isUpdating = loadingById[orderId] || false;

  // No need to fetch here - parent component handles it

  const handleEditOrder = () => {
    console.log("Edit order:", orderId);
  };

  const handleUpdatePayment = () => {
    console.log("Update payment for order:", orderId);
  };

  const handleCancelOrder = () => {
    if (!confirm("Are you sure you want to cancel this order?")) return;

    dispatch(orderActions.rejectOrder(orderId));
  };

  const handleMoreActions = () => {
    console.log("More actions for order:", orderId);
  };

  if (detailsLoading) {
    return (
      <div className="flex items-center gap-2">
        <div className="h-8 w-20 bg-muted rounded animate-pulse"></div>
        <div className="h-8 w-24 bg-muted rounded animate-pulse"></div>
        <div className="h-8 w-16 bg-muted rounded animate-pulse"></div>
      </div>
    );
  }

  const canEdit =
    selectedOrder?.current_order_stage === "CREATED" ||
    selectedOrder?.current_order_stage === "CONFIRMED";
  const canCancel =
    selectedOrder && selectedOrder.current_order_stage !== "CANCELLED";
  const needsPaymentUpdate =
    selectedOrder?.payment_status === "FAILED" ||
    selectedOrder?.payment_status === "CREATED";

  return (
    <div className="flex items-center gap-2">
      <ButtonOutline
        size="sm"
        onClick={handleEditOrder}
        disabled={!canEdit}
        className="flex items-center gap-2 text-xs"
      >
        <Edit className="h-3 w-3" />
        Edit Order
      </ButtonOutline>

      {needsPaymentUpdate && (
        <ButtonOutline
          size="sm"
          onClick={handleUpdatePayment}
          className="flex items-center gap-2 text-xs"
        >
          <CreditCard className="h-3 w-3" />
          Update Payment
        </ButtonOutline>
      )}

      {canCancel && (
        <ButtonDestructive
          size="sm"
          onClick={handleCancelOrder}
          disabled={isUpdating}
          className="flex items-center gap-2 text-xs"
        >
          <Ban className="h-3 w-3" />
          {isUpdating ? "Cancelling..." : "Cancel"}
        </ButtonDestructive>
      )}

      <ButtonOutline
        size="sm"
        onClick={handleMoreActions}
        className="flex items-center gap-2 text-xs"
      >
        <MoreHorizontal className="h-3 w-3" />
        More
      </ButtonOutline>
    </div>
  );
};

export default OrderActions;
